import { render } from "./IconUnlink.vue?vue&type=template&id=66968b7f&scoped=true"
import script from "./IconUnlink.vue?vue&type=script&lang=js"
export * from "./IconUnlink.vue?vue&type=script&lang=js"

import "./IconUnlink.vue?vue&type=style&index=0&id=66968b7f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66968b7f"]])

export default __exports__